import { Link, Breadcrumbs as MUIBreadcrumbs } from '@mui/material';
import isNil from 'lodash/isNil';
import { Link as RouterLink } from 'react-router-dom';
import { ICONS } from '@/assets/icons';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import Iconify from '@/components/Iconify';
import { ICON_SIZE_MAP } from '@/config';
import { BreadcrumbLink } from './types';

type Props = {
  links: BreadcrumbLink[];
};

export function PBreadcrumbs({ links }: Props) {
  if (links.length === 0) {
    return null;
  }

  return (
    <MUIBreadcrumbs
      aria-label="Breadcrumb"
      separator={<Iconify icon={ICONS.CHEVRON_RIGHT} width={ICON_SIZE_MAP.sm} height={ICON_SIZE_MAP.sm} />}
    >
      {links.map((link) =>
        !isNil(link.href) ? (
          <Link
            aria-current={!isNil(link.isCurrent) && link.isCurrent ? 'page' : undefined}
            variant="body2"
            component={RouterLink}
            to={link.href ?? '#'}
            sx={{
              lineHeight: 2,
              display: 'flex',
              alignItems: 'center',
              color: 'text.primary',
              '& > div': { display: 'inherit' },
            }}
          >
            {link.name}
          </Link>
        ) : (
          <PTypography
            key={link.name}
            variant="body2"
            color="secondary"
            aria-current={!isNil(link.isCurrent) && link.isCurrent ? 'page' : undefined}
          >
            {link.name}
          </PTypography>
        ),
      )}
    </MUIBreadcrumbs>
  );
}
